<div class="content">
  <div class="header">
    <label class="headerLabel">Non-SureFlow Unit Details</label>
  </div>
  <div class="inputRow">
    @if (showTagInput) {
      <mat-form-field class="fullWidth">
        <mat-label class="inputLabel">Unit Tag</mat-label>
        <input matInput [(ngModel)]="unitData.userTag"/>
      </mat-form-field>
    }
  </div>
  <div class="inputRow">
    @if (hasCooling()) {
      <mat-form-field class="inputField">
        <mat-label class="inputLabel">{{ 'Cooling Total Capacity (' + getCapacityUnits() + ')' }}</mat-label>
        <input matInput [(ngModel)]="unitData.coolingTargetTotalLoad" type="number"/>
      </mat-form-field>
    }
    <span class="spacer"></span>
    @if (hasHeating()) {
      <mat-form-field class="inputField">
        <mat-label class="inputLabel">{{ 'Heating Total Capacity (' + getCapacityUnits() + ')' }}</mat-label>
        <input matInput [(ngModel)]="unitData.heatingTargetTotalLoad" type="number"/>
      </mat-form-field>
    }
  </div>
  <div class="inputRow">
    @if (hasCooling()) {
      <mat-form-field class="inputField">
        <mat-label class="inputLabel">{{ 'Cooling Flow Rate (' + getFlowRateUnits() + ')' }}</mat-label>
        <input matInput [(ngModel)]="unitData.coolingFluidFlowRate" type="number"/>
      </mat-form-field>
    }
    <span class="spacer"></span>
    @if (hasHeating()) {
      <mat-form-field class="inputField">
        <mat-label class="inputLabel">{{ 'Heating Flow Rate (' + getFlowRateUnits() + ')' }}</mat-label>
        <input matInput [(ngModel)]="unitData.heatingFluidFlowRate" type="number"/>
      </mat-form-field>
    }
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button class="dialogButton warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
    <button class="dialogButton primary-button" matButton="elevated" (click)="save()">Save</button>
  </div>
</div>
